import { z } from 'zod'

export interface AppModuleSetting {
  moduleKey: string
  label: string
  isActive: boolean
  updatedAt: string
}

export interface AppModuleSettingsResult {
  modules: AppModuleSetting[]
  meta: {
    source: 'supabase' | 'fixtures' | 'fixture-fallback'
    retrievedAt: string
    fallbackReason?: string
  }
}

export interface SetAppModuleActiveCommand {
  moduleKey: string
  isActive: boolean
}

export const appModuleSettingRowSchema = z.object({
  module_key: z.string().min(1),
  label: z.string().min(1),
  is_active: z.boolean(),
  updated_at: z.string(),
})

export const setAppModuleActiveResultSchema = z.object({
  moduleKey: z.string().min(1),
  label: z.string().min(1),
  isActive: z.boolean(),
  updatedAt: z.string(),
})
